import { Controller } from "react-hook-form";
import { FormErrorLabel } from "../FormErrorLabel";
import { FormLabel } from "../FormLabel";
import { BadgeInfo } from "lucide-react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "../ui";
import { DateRangePicker } from "../DateRangePicker";

const FormDateRangePicker2 = ({
  name,
  label,
  control,
  error,
  isRequired,
  onChange,
  info,
  ...rest
}: any) => {
  return (
    <div className="relative flex flex-col items-start gap-1">
      {label && (
        <FormLabel>
          {label} <span className="text-red-700">{isRequired ? "*" : ""}</span>
          {info && (
            <TooltipProvider>
              <Tooltip>
                <TooltipTrigger className="mx-1">
                  <BadgeInfo className="h-3 w-3 stroke-yellow-600" />
                </TooltipTrigger>
                <TooltipContent>
                  <p>{info}</p>
                </TooltipContent>
              </Tooltip>
            </TooltipProvider>
          )}
        </FormLabel>
      )}
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <DateRangePicker
            // DateRangePicker expects `value` and `onChange` props
            value={field.value}
            onChange={(date: any) => {
              field.onChange(date);
              onChange && onChange(date);
            }}
            {...rest}
          />
        )}
      />
      {error && <FormErrorLabel>{error}</FormErrorLabel>}
    </div>
  );
};
export default FormDateRangePicker2;
